import { render } from "./CInputToggle.vue?vue&type=template&id=3573e8f7"
import script from "./CInputToggle.vue?vue&type=script&lang=js"
export * from "./CInputToggle.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__